import { FC, memo } from 'react';
import type { Slug, UrlFriendlySlug } from '@bridebook/toolbox/src/types';
import { ISearchPageQuery } from '@bridebook/web/app-shared/lib/search/types';

export type Location = { query: { area: string; slug: Slug | UrlFriendlySlug } };

export interface SearchPaginationComponentChildrenProps {
  totalPages: number;
  activePage: number;

  onSelect({ selected }: { selected: number }): void;
}

interface IProps {
  fullQuery: ISearchPageQuery;
  location: Location;
  totalResults: number;
  pageSize: number;

  onLoadMoreSuppliers(location: Location, page: number): void;

  children(data: {
    totalPages: number;
    onSelect: ({ selected }: { selected: number }) => void;
    activePage: number;
  }): JSX.Element;
}

const SearchPagination = ({
  totalResults,
  pageSize,
  fullQuery,
  location,
  onLoadMoreSuppliers,
  children,
}: IProps) => {
  const totalPages: number = Math.ceil(totalResults / pageSize);
  const loadMoreSuppliersPagination = ({ selected }: { selected: number }) => {
    onLoadMoreSuppliers(location, selected + 1);
  };

  return children({
    totalPages,
    onSelect: loadMoreSuppliersPagination,
    activePage: Number((fullQuery?.page || 1) - 1),
  });
};

export default memo(SearchPagination) as FC<IProps>;
